import { CLEAR_GENERIC_USER, LOGOUT, SET_GENERIC_USER } from "../actions/type";

var initailState=[];

const genericUser =( state = initailState , action) =>{
    switch (action.type) {
        case SET_GENERIC_USER:
            return [
                ...state,
                ...action.payload,
            ];
        case CLEAR_GENERIC_USER:
            return initailState;
        case LOGOUT:
            return initailState;
        default:
            return state;
    }
};

export default genericUser;